module.exports = __webpack_public_path__ + "static/media/Screenshot_1-thumb.fe56b5be.png";